import {
  APPROVER_DATA,
  EMPLOYEE_DATA,
  GET_DASHBOARD_DATA,
  GET_NOTIFICATION_MESSAGE,
  GET_USER_DETAILS,
  GET_USER_IMAGE,
  IS_VALID_APPROVER,
  IS_VALID_TOKEN,
  MEMBER_OR_LEADER_GRID,
  REQUEST_TYPE,
  SEASONS_STATUS_LIST,
  SESSION_EXPIRED,
  SET_ACTIVE_TAB,
  SET_PROGRESS_BAR,
} from "../constants/action-types";

export function getEmployeesData(data) {
  let payload = data;
  return { type: EMPLOYEE_DATA, payload };
}

export function setMemberOrLeaderView(data) {
  let payload = data;
  return { type: MEMBER_OR_LEADER_GRID, payload };
}

export function getApproverData(data) {
  let payload = data;
  return { type: APPROVER_DATA, payload };
}

export function getRequestType(data) {
  let payload = data;
  return { type: REQUEST_TYPE, payload };
}

export function setSessionExpired(data) {
  let payload = data;
  return { type: SESSION_EXPIRED, payload };
}

export function getUserDetails(data) {
  let payload = data;
  return { type: GET_USER_DETAILS, payload };
}

export function isValidApprover(data) {
  let payload = data;
  return { type: IS_VALID_APPROVER, payload };
}

export function setProgressBar(data) {
  let payload = data;
  return { type: SET_PROGRESS_BAR, payload };
}

export function setActiveTab(data) {
  let payload = data;
  return { type: SET_ACTIVE_TAB, payload };
}

export function isValidToken(data) {
  let payload = data;
  return { type: IS_VALID_TOKEN, payload };
}

export function statusSeasonList(data) {
  let payload = data;
  return { type: SEASONS_STATUS_LIST, payload };
}

export function setSuperAdminFlag(data) {
  let payload = data;
  return { type: "SET_SUPER_ADMIN_FLAG", payload };
}

export function getUserImage(data) {
  let payload = data;
  return { type: GET_USER_IMAGE, payload };
}

export function getNotificationMessage(data) {
  let payload = data;
  return { type: GET_NOTIFICATION_MESSAGE, payload };
}

export function getDashboardData(data) {
  let payload = data;
  return { type: GET_DASHBOARD_DATA, payload };
}
